module.exports = __webpack_public_path__ + "img/logo_gottingen.9ed0d675.png";